// import { Slot } from "@radix-ui/react-slot";
// import { cn } from "@shared/lib/utils";
// import { cva, type VariantProps } from "class-variance-authority";
// import * as React from "react";

// const buttonVariants = cva(
//   "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
//   {
//     variants: {
//       variant: {
//         default: "bg-primary text-primary-foreground hover:bg-primary/90",
//         destructive:
//           "bg-destructive text-destructive-foreground hover:bg-destructive/90",
//         outline:
//           "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
//         secondary:
//           "bg-secondary text-secondary-foreground hover:bg-secondary/80",
//         ghost: "hover:bg-accent hover:text-accent-foreground",
//         link: "text-primary underline-offset-4 hover:underline",
//       },
//       size: {
//         default: "h-10 px-4 py-2",
//         sm: "h-9 rounded-md px-3",
//         lg: "h-11 rounded-md px-8",
//         icon: "h-10 w-10",
//       },
//     },
//     defaultVariants: {
//       variant: "default",
//       size: "default",
//     },
//   }
// );

// // Simple HTML/CSS spinner component
// const Spinner = ({ className }: { className?: string }) => (
//   <div
//     className={cn(
//       "inline-block h-4 w-4 border-2 border-current border-r-transparent rounded-full animate-spin",
//       className
//     )}
//   />
// );
// type TooltipPosition = "top" | "bottom" | "left" | "right";

// const getTooltipPositionClasses = (position: TooltipPosition) => {
//   switch (position) {
//     case "top":
//       return {
//         container: "bottom-full left-1/2 transform -translate-x-1/2 mb-2",
//         arrow:
//           "absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-white",
//       };
//     case "bottom":
//       return {
//         container: "top-full left-1/2 transform -translate-x-1/2 mt-2",
//         arrow:
//           "absolute bottom-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-b-4 border-transparent border-b-white",
//       };
//     case "left":
//       return {
//         container: "right-full top-1/2 transform -translate-y-1/2 mr-2",
//         arrow:
//           "absolute left-full top-1/2 transform -translate-y-1/2 w-0 h-0 border-t-4 border-b-4 border-l-4 border-transparent border-l-white",
//       };
//     case "right":
//       return {
//         container: "left-full top-1/2 transform -translate-y-1/2 ml-2",
//         arrow:
//           "absolute right-full top-1/2 transform -translate-y-1/2 w-0 h-0 border-t-4 border-b-4 border-r-4 border-transparent border-r-white",
//       };
//     default:
//       return {
//         container: "bottom-full left-1/2 transform -translate-x-1/2 mb-2",
//         arrow:
//           "absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-white",
//       };
//   }
// };

// export interface ButtonProps
//   extends React.ButtonHTMLAttributes<HTMLButtonElement>,
//     VariantProps<typeof buttonVariants> {
//   asChild?: boolean;
//   tooltip?: any;
//   isLoading?: boolean;
//   tooltipPosition?: TooltipPosition;
// }

// const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
//   (
//     {
//       className,
//       variant,
//       size,
//       asChild = false,
//       tooltip,
//       isLoading = false,
//       children,
//       tooltipPosition = "top",
//       ...props
//     },
//     ref
//   ) => {
//     const Comp = asChild ? Slot : "button";

//     const buttonElement = (
//       <Comp
//         className={cn(buttonVariants({ variant, size, className }))}
//         ref={ref}
//         disabled={isLoading || props.disabled}
//         {...props}
//       >
//         {isLoading && <Spinner className="h-4 w-4" />}
//         {children}
//       </Comp>
//     );

//     // If tooltip is provided, wrap with tooltip
//     if (tooltip) {
//       const positionClasses = getTooltipPositionClasses(tooltipPosition);

//       return (
//         <div className="relative group inline-block">
//           {buttonElement}
//           <div
//             className={cn(
//               "absolute px-3 py-1 bg-white text-black text-sm rounded-md border border-gray-200 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none z-50",
//               positionClasses.container
//             )}
//           >
//             {tooltip}
//             <div className={positionClasses.arrow}></div>
//           </div>
//         </div>
//       );
//     }

//     return buttonElement;
//   }
// );
// Button.displayName = "Button";

// export { Button, buttonVariants };
// import { Slot } from "@radix-ui/react-slot";
// import { cn } from "@shared/lib/utils";
// import { cva, type VariantProps } from "class-variance-authority";
// import * as React from "react";
// import { useLocation } from "react-router-dom";

// const buttonVariants = cva(
//   "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
//   {
//     variants: {
//       variant: {
//         default: "bg-primary text-primary-foreground hover:bg-primary/90",
//         destructive:
//           "bg-destructive text-destructive-foreground hover:bg-destructive/90",
//         outline:
//           "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
//         secondary:
//           "bg-secondary text-secondary-foreground hover:bg-secondary/80",
//         ghost: "hover:bg-accent hover:text-accent-foreground",
//         link: "text-primary underline-offset-4 hover:underline",
//       },
//       size: {
//         default: "h-10 px-4 py-2",
//         sm: "h-9 rounded-md px-3",
//         lg: "h-11 rounded-md px-8",
//         icon: "h-10 w-10",
//       },
//     },
//     defaultVariants: {
//       variant: "default",
//       size: "default",
//     },
//   }
// );


//  const dummyPermissions = {
//   "status": "success",
//   "data": {
//     "userInfo": {
//       "userId": 80511,
//       "username": "john.peterson.wlu@yopmail.com",
//       "utilityId": 397,
//       "roleCodes": ["Tenant Admin"],
//       "isSetupCompleted": true,
//       "landingPage": "onboarding/system-admin/dashboard",
//       "landingModule": "Onboarding"
//     },
//     "permissions": {
//       "modules": {
//         "CX": {
//           "moduleInfo": {
//             "name": "Consumer Services",
//             "description": "Customer account and service management"
//           },
//           "submodules": {
//             "MANAGEMENT": {
//               "Accounts": {
//                 "routes": ["/cx/consumer-management"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               },
//               "Payments": {
//                 "routes": ["/cx/payments"],
//                 "canRead": true,
//                 "canCreate": true,
//                 "canUpdate": false,
//                 "canDelete": false,
//                 "canExport": true
//               }
//             }
//           }
//         },
//         "MX": {
//           "moduleInfo": {
//             "name": "Meter Data",
//             "description": "Meter reading and consumption data"
//           },
//           "submodules": {
//             "DEVICE MANAGEMENT": {
//               "Meter": {
//                 "routes": ["/mx/device-management/meter"],
//                 "canRead": true,
//                 "canCreate": false,
//                 "canUpdate": true,
//                 "canDelete": false,
//                 "canExport": true
//               }
//             }
//           }
//         }
//       },
//       "routePermissions": {
//         "/utility/utility-setup/dashoard": {
//           "create": false,
//           "read": true,
//           "update": true,
//           "delete": false,
//           "export": false
//         },
//         "/cx/consumer-management/create": {
//           "create": true,
//           "read": true,
//           "update": false,
//           "delete": false,
//           "export": false
//         },
//         "/cx/consumer-management/:id": {
//           "create": false,
//           "read": true,
//           "update": true,
//           "delete": false,
//           "export": true
//         },
//         "/cx/payments": {
//           "create": true,
//           "read": true,
//           "update": false,
//           "delete": false,
//           "export": true
//         },
//         "/cx/payments/create": {
//           "create": true,
//           "read": true,
//           "update": false,
//           "delete": false,
//           "export": false
//         },
//         "/mx/device-management/meter": {
//           "create": false,
//           "read": true,
//           "update": true,
//           "delete": false,
//           "export": true
//         },
//         "/mx/device-management/meter/new": {
//           "create": false,
//           "read": true,
//           "update": false,
//           "delete": false,
//           "export": false
//         },
//         "/mx/device-management/meter/:id": {
//           "create": false,
//           "read": true,
//           "update": true,
//           "delete": false,
//           "export": true
//         },
//         "/bx/dashboard": {
//           "create": true,
//           "read": true,
//           "update": true,
//           "delete": true,
//           "export": true
//         },
//         "/wx/dashboard": {
//           "create": true,
//           "read": true,
//           "update": true,
//           "delete": true,
//           "export": true
//         }
//       }
//     }
//   }
// }

// const Spinner = ({ className }: { className?: string }) => (
//   <div
//     className={cn(
//       "inline-block h-4 w-4 border-2 border-current border-r-transparent rounded-full animate-spin",
//       className
//     )}
//   />
// );

// type TooltipPosition = "top" | "bottom" | "left" | "right";

// const getTooltipPositionClasses = (position: TooltipPosition) => {
//   switch (position) {
//     case "top":
//       return {
//         container: "bottom-full left-1/2 transform -translate-x-1/2 mb-2",
//         arrow:
//           "absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-white",
//       };
//     case "bottom":
//       return {
//         container: "top-full left-1/2 transform -translate-x-1/2 mt-2",
//         arrow:
//           "absolute bottom-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-b-4 border-transparent border-b-white",
//       };
//     case "left":
//       return {
//         container: "right-full top-1/2 transform -translate-y-1/2 mr-2",
//         arrow:
//           "absolute left-full top-1/2 transform -translate-y-1/2 w-0 h-0 border-t-4 border-b-4 border-l-4 border-transparent border-l-white",
//       };
//     case "right":
//       return {
//         container: "left-full top-1/2 transform -translate-y-1/2 ml-2",
//         arrow:
//           "absolute right-full top-1/2 transform -translate-y-1/2 w-0 h-0 border-t-4 border-b-4 border-r-4 border-transparent border-r-white",
//       };
//     default:
//       return {
//         container: "bottom-full left-1/2 transform -translate-x-1/2 mb-2",
//         arrow:
//           "absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-white",
//       };
//   }
// };

// // ========================================
// // PERMISSION LOGIC - INTERNAL TO BUTTON
// // ========================================

// type PermissionAction = "create" | "read" | "update" | "delete" | "export";

// /**
//  * Match current route with permission route pattern
//  * Handles dynamic params like :id
//  */
// const matchRoute = (currentRoute: string, permissionRoute: string): boolean => {
//   if (currentRoute === permissionRoute) return true;
  
//   const pattern = permissionRoute
//     .replace(/:[^/]+/g, '[^/]+')
//     .replace(/\//g, '\\/');
  
//   const regex = new RegExp(`^${pattern}$`);
//   return regex.test(currentRoute);
// };

// /**
//  * Check permission from localStorage
//  */
// const checkPermission = (currentRoute: string, action: PermissionAction): boolean => {
//   try {
//     const cached = dummyPermissions;
//     console.log("cached", JSON.stringify(cached, null, 2));
//     if (!cached) return true; // If no permissions cached, allow all (fallback)
    
//     const routePermissions = cached?.data?.permissions?.routePermissions;
    
//     if (!routePermissions) return true; // No permissions structure = allow all
    
//     // Try exact match first
//     if (routePermissions[currentRoute]) {
//       return routePermissions[currentRoute][action] === true;
//     }
    
//     // Try pattern matching for dynamic routes
//     for (const [route, perms] of Object.entries(routePermissions)) {
//       if (matchRoute(currentRoute, route)) {
//         return perms[action] === true;
//       }
//     }
    
//     // No matching route found = allow by default (or you can change to false to deny)
//     return true;
//   } catch (error) {
//     console.error('Error checking permissions:', error);
//     return true; // On error, allow (safe default)
//   }
// };

// /**
//  * Detect action type from button content/props
//  */
// const detectAction = (children: React.ReactNode, type?: string): PermissionAction | null => {
//   const childText = typeof children === 'string' 
//     ? children.toLowerCase() 
//     : React.Children.toArray(children)
//         .filter((child) => typeof child === 'string')
//         .join(' ')
//         .toLowerCase();
  
//   // Detect from button text
//   if (childText.includes('create') || childText.includes('add') || childText.includes('new')) {
//     return 'create';
//   }
//   if (childText.includes('edit') || childText.includes('update') || childText.includes('modify')) {
//     return 'update';
//   }
//   if (childText.includes('delete') || childText.includes('remove')) {
//     return 'delete';
//   }
//   if (childText.includes('export') || childText.includes('download')) {
//     return 'export';
//   }
  
//   // Detect from button type
//   if (type === 'submit') {
//     return 'create'; // Forms usually create/update
//   }
  
//   return null; // Unknown action = show button (don't block UI buttons)
// };

// // ========================================
// // BUTTON COMPONENT
// // ========================================

// export interface ButtonProps
//   extends React.ButtonHTMLAttributes<HTMLButtonElement>,
//     VariantProps<typeof buttonVariants> {
//   asChild?: boolean;
//   tooltip?: any;
//   isLoading?: boolean;
//   tooltipPosition?: TooltipPosition;
// }

// const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
//   (
//     {
//       className,
//       variant,
//       size,
//       asChild = false,
//       tooltip,
//       isLoading = false,
//       children,
//       tooltipPosition = "top",
//       disabled,
//       type,
//       ...props
//     },
//     ref
//   ) => {
//     const location = useLocation();
    
//     // Auto-detect action and check permission
//     const action = detectAction(children, type);
//     const hasPermission = action ? checkPermission(location.pathname, action) : true;
    
//     // Hide button if no permission
//     if (!hasPermission) {
//       return null;
//     }
    
//     const Comp = asChild ? Slot : "button";
//     const showSpinner = isLoading && !asChild;

//     const buttonElement = (
//       <Comp
//         className={cn(buttonVariants({ variant, size, className }))}
//         ref={ref}
//         disabled={isLoading || disabled}
//         type={type}
//         {...props}
//       >
//         {showSpinner && <Spinner className="h-4 w-4" />}
//         {children}
//       </Comp>
//     );

//     if (tooltip) {
//       const positionClasses = getTooltipPositionClasses(tooltipPosition);
//       return (
//         <div className="relative group inline-block">
//           {buttonElement}
//           <div
//             className={cn(
//               "absolute px-3 py-1 bg-white text-black text-sm rounded-md border border-gray-200 shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap pointer-events-none z-50",
//               positionClasses.container
//             )}
//           >
//             {tooltip}
//             <div className={positionClasses.arrow}></div>
//           </div>
//         </div>
//       );
//     }

//     return buttonElement;
//   }
// );

// Button.displayName = "Button";

// export { Button, buttonVariants };


// src/components/ui/Button.tsx
// src/components/ui/Button.tsx

import { Slot } from "@radix-ui/react-slot";
import { cn } from "@shared/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";
import { useLocation } from "react-router-dom";
import { useGlobalUserPermission } from "@shared/hooks/useGlobalUserPermission";
import { checkPermission, detectActionFromContent } from "@core/permissions/permissionChecker";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@shared/ui/tooltip";

// ==========================================
// BUTTON VARIANTS (STYLES)
// ==========================================
const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground hover:bg-primary/90",
        destructive:
          "bg-destructive text-destructive-foreground hover:bg-destructive/90",
        outline:
          "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-10 px-4 py-2",
        sm: "h-9 rounded-md px-3",
        lg: "h-11 rounded-md px-8",
        icon: "h-10 w-10",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

// ==========================================
// SPINNER COMPONENT
// ==========================================
const Spinner = ({ className }: { className?: string }) => (
  <div
    className={cn(
      "inline-block h-4 w-4 border-2 border-current border-r-transparent rounded-full animate-spin",
      className
    )}
  />
);

// ==========================================
// BUTTON PROPS INTERFACE
// ==========================================
export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
  tooltip?: any;
  isLoading?: boolean;
  tooltipPosition?: "top" | "bottom" | "left" | "right";
}

// ==========================================
// BUTTON COMPONENT
// ==========================================
const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      className,
      variant,
      size,
      asChild = false,
      tooltip,
      isLoading = false,
      children,
      tooltipPosition = "top",
      disabled,
      type,
      ...props
    },
    ref
  ) => {
    // ===== HOOKS =====
    const location = useLocation();
    const permissionData = useGlobalUserPermission();

    // ===== PERMISSION CHECK =====
    const action = detectActionFromContent(children);

    if (action) {
      const hasPermission = checkPermission(
        location.pathname,
        action,
        permissionData
      );

      if (!hasPermission) {
        console.log(
          `🚫 Button hidden: "${children}" (action: ${action}) on route: ${location.pathname}`
        );
        return null;
      }

      console.log(
        `✅ Button shown: "${children}" (action: ${action}) on route: ${location.pathname}`
      );
    } else {
      console.log(
        `ℹ️ Button shown (no action detected): "${children}" on route: ${location.pathname}`
      );
    }

    // ===========================
    const Comp = asChild ? Slot : "button";
    const showSpinner = isLoading && !asChild;

    const buttonElement = (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        disabled={isLoading || disabled}
        type={type}
        {...props}
      >
        {showSpinner && <Spinner className="h-4 w-4" />}
        {children}
      </Comp>
    );

    // ===== TOOLTIP WRAPPER (shadcn) =====
    if (tooltip) {
      return (
        <TooltipProvider delayDuration={100}>
          <Tooltip>
            <TooltipTrigger asChild>{buttonElement}</TooltipTrigger>
            <TooltipContent side={tooltipPosition}
            className="max-w-[400px] break-words whitespace-normal"
            >{tooltip}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      );
    }

    return buttonElement;
  }
);

Button.displayName = "Button";

export { Button, buttonVariants };
